module.exports = __webpack_public_path__ + "img/TheMJ_icon.2f186521.png";